import ContactItem from '../../../../components/common/contact/ContactItem';
import { getListedEntryKey } from '../../../../utils/getListedEntryKey';
import { IContactSectionEntry } from '../../../../contentful/types/IContactSectionEntry';
import { Section, SectionHeader } from './Section';
import { IAirlineSectionEntry } from '../../../../contentful/types/IAirlineSection';
import CardsContainer from '../../../../components/common/cards/CardsContainer';
import { getValidExternalUrl } from '../../../../utils/getValidExternalUrl';
import { getContactImageSource } from '../../../../utils/getContactImageSource';
import { isEmail } from '../../../../utils/isEmail';

interface IContactSectionProps {
	section: IContactSectionEntry | IAirlineSectionEntry;
}

export default function ContactSection({ section }: IContactSectionProps) {
	const getLinkHref = (url?: string) => {
		if (isEmail(url)) {
			return `mailto:${url}`;
		}

		if (!url) return '';
		if (url.startsWith('mailto:')) return url;
		return getValidExternalUrl(url);
	};

	return (
		<Section>
			{section.fields.title && (
				<SectionHeader>{section.fields.title}</SectionHeader>
			)}
			<CardsContainer>
				{section.fields.items?.map((item, index) =>
					item.contentType === 'contact-item' ? (
						<ContactItem
							key={getListedEntryKey(item, index)}
							title={item.fields.title}
							subtitle={item.fields.subtitle}
							imageSource={getContactImageSource(
								item.fields.image,
								section.fields.imageOrientation ?? 'landscape',
							)}
							phoneNumber={item.fields.phoneNumber}
							linkTitle={item.fields.linkText}
							linkHref={getLinkHref(item.fields.linkUrl)}
							imageAlt={item.fields.image?.fields.description}
							imageOrientation={section.fields.imageOrientation}
						/>
					) : (
						<ContactItem
							key={getListedEntryKey(item, index)}
							title={item.fields.name}
							subtitle={item.fields.subtitle}
							imageSource={getContactImageSource(
								item.fields.logo,
								section.fields.imageOrientation ?? 'landscape',
							)}
							phoneNumber={item.fields.phoneNumber}
							linkTitle={item.fields.description}
							linkHref={
								(item.fields.website &&
									getValidExternalUrl(item.fields.website)) ||
								''
							}
							imageAlt={item.fields.logo?.fields.description}
							imageOrientation={section.fields.imageOrientation}
						/>
					),
				)}
			</CardsContainer>
		</Section>
	);
}
